<template>
  <div class="fixed top-0 left-0 bottom-0 right-0 flex items-center justify-center bg-white dark:bg-gray-900 z-[2000]">
    <at-loading />
  </div>
</template>

<script setup>
  import { AtLoading } from '@packages/aliftech-ui';
</script>
